export enum MoSuccessVisionBannerState {
	OPTEDININSUFFICIENTFUNDS = "optedInInsufficientFunds",
	VISIONFEENOTACTIVE = "visionFeeNotActive"
}
